// src/UserSettings.js
import React from 'react';
import NavBar from './NavBar';
import './UserSettings.css';
import { Box } from '@mui/material';

function UserSettings() {
  return (
    <div className="usersettings-container">
      <NavBar />

      {/* Dummy bar offset: ~64px + 20px = 84px */}
      <Box sx={{ height: 84 }} />

      <div className="usersettings-content">
        <h1 style={{ color: '#fff' }}>User Settings</h1>
        <p style={{ color: '#ccc' }}>
          Here, the user can change their password, update profile info, etc.
        </p>
      </div>
    </div>
  );
}

export default UserSettings;